import React, { forwardRef } from 'react';

import {
  ExtraFieldsConfigLocation,
  RecordTypeFragment,
} from '../../../__generated__/graphql';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import {
  ExtraFieldsAreaContentSimple,
  ExtraFieldsAreaContentSimpleRef,
} from '../../ExtraFields/ExtraFieldsArea/ExtraFieldsAreaContentSimple';
import { ExtraFieldInternalValue } from '../../ExtraFields/extraFieldInternalValue';
import { ExtraFieldFormInfoType } from '../../ExtraFields/types';

type Props = {
  requestFormId: string;
  extraFieldInfos: readonly ExtraFieldFormInfoType[] | null;
  recordTypes: readonly RecordTypeFragment[] | null;
  recordTypeName: string | null;
  values: readonly ExtraFieldInternalValue[];
  onChange: (
    extraFields: ExtraFieldInternalValue[],
    recordTypeName: string | undefined,
  ) => void;
};

export const StepObjectCreate = forwardRef<
  ExtraFieldsAreaContentSimpleRef,
  Props
>(
  (
    {
      requestFormId,
      recordTypeName,
      extraFieldInfos,
      values,
      onChange,
      recordTypes,
    },
    ref,
  ) => {
    const t = useNamespacedTranslation('changeRequests.requestForm');

    if (!extraFieldInfos) {
      return <div>{t('errors.objectCreateNotSupported')}</div>;
    }

    return (
      <ExtraFieldsAreaContentSimple
        ref={ref}
        onChange={onChange}
        values={values}
        recordTypeName={recordTypeName}
        formFields={extraFieldInfos}
        availableRecordTypes={recordTypes ?? []}
        extraFieldsConfigReference={{
          recordId: requestFormId,
          location: ExtraFieldsConfigLocation.RequestForm,
        }}
      />
    );
  },
);
